import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { createTodo, selectTodosLoading, updateTodoTags } from 'store/slices/todosSlice';
import {
  fetchTodoTags,
  selectAllTodoTags,
  selectTodoTagsStatus,
} from 'store/slices/todoTagsSlice';
import Page from 'components/layout/Page/Page';
import { toMarkdownString } from 'utils/markdown/markdown';
import TodoTabs from './components/TodoTabs/TodoTabs';
import TodoForm from './components/TodoForm/TodoForm';

export default function AddTodo() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loading = useSelector(selectTodosLoading);
  const todoTags = useSelector(selectAllTodoTags);
  const todoTagsStatus = useSelector(selectTodoTagsStatus);

  useEffect(() => {
    if (todoTagsStatus === 'idle') {
      dispatch(fetchTodoTags());
    }
  }, [dispatch, todoTagsStatus]);

  const onSubmit = async (data) => {
    try {
      const { tagNames = [], ...todoData } = data;
      const createdTodo = await dispatch(createTodo({
        ...todoData,
        body: toMarkdownString(todoData.body),
      })).unwrap();

      if (tagNames.length > 0) {
        await dispatch(updateTodoTags({
          id: createdTodo._id,
          tagNames,
        })).unwrap();
      }

      navigate('/todos');
    } catch (error) {
      console.error('Failed to create todo:', error);
    }
  };

  return (
    <Page title="Create Todo" headerActions={<TodoTabs />}>
      <div className="max-w-2xl mx-auto">
        <TodoForm
          onSubmit={onSubmit}
          availableTagNames={todoTags.map((todoTag) => todoTag.name)}
          saving={loading}
          submitLabel="Create"
        />
      </div>
    </Page>
  );
}
